<script setup lang="ts">
import axios, { type AxiosRequestConfig } from "axios";
import { api_guest } from "@/common/api";
import { onMounted } from "vue";
import { useUserInfoStore } from "@/stores/userInfoStore";
import { axiosInstance } from "@/common/request";
import { ElMessage ,ElFooter} from "element-plus";

onMounted(() => {

});
</script>

<template>
  <router-view> </router-view>
</template>

<style scoped></style>
